// extracted by mini-css-extract-plugin
export default {"Price":"Price_Price__UxAo-","PriceText":"Price_PriceText__ZFpuA"};